import React, { useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import Select from "react-select";
import "./Accuracy_Form.css";
import {
  Create,
  GetAll,
} from "../../../../../../../../../src/features/admin/quality_management/process_requirement/accuracy/Slice";
import {
  AllChemist,
  AllParameter,
  allSampleManagement,
  AllTestMethod,
  allVerificationType,
} from "../../../../../../../../features/admin/common/Slice";
import { useDispatch, useSelector } from "react-redux";
import { Controller, useForm } from "react-hook-form";

function Accuracy_Form({ onProceed }) {
  const {
    handleSubmit,
    register,
    formState: { errors },
    reset,
    control,
    setError,
    clearErrors,
  } = useForm({
    defaultValues: {
      parameters: [],
    },
  });

  const dispatch = useDispatch();

  const all_parameter = useSelector((state) => state.common.all_parameter);
  const all_verification_type = useSelector(
    (state) => state.common.all_verification_type,
  );

  useEffect(() => {
    dispatch(AllParameter());
    dispatch(allVerificationType());
  }, [dispatch]);

  const onSubmit = async (data) => {
    try {
      clearErrors(["certified_param", "result_param"]);

      const certifiedFilled = data.parameters?.filter((p) =>
        p?.certified_value?.trim(),
      );

      const resultFilled = data.parameters?.filter((p) =>
        p?.result_value?.trim(),
      );

      if (!certifiedFilled || certifiedFilled.length === 0) {
        setError("certified_param", {
          type: "manual",
          message: "At least one Certified Value Parameter is required",
        });
        return;
      }

      if (!resultFilled || resultFilled.length === 0) {
        setError("result_param", {
          type: "manual",
          message: "At least one Result Value is required",
        });
        return;
      }

      const payload = {
        test_method_id: data.test_method_id,
        sample_id: data.sample_management_id,
        type_of_verification_id: data.type_of_verification_id,
        checked_by: data.chemist_assigned_id,
        // certified_value: data.certified_value,
        remark: data.remark,
        date: data.date,
        parameters: data.parameters.filter(
          (p) => p.certified_value || p.result_value,
        ),
      };

      const res = await dispatch(Create(payload));

      if (res.meta.requestStatus === "fulfilled") {
        await dispatch(GetAll());
        reset();
      }
    } catch (error) {
      console.error(error);
    }
  };
  const all_sample_management = useSelector(
    (state) => state.common.all_sample_management,
  );
  const all_test_method = useSelector((state) => state.common.all_test_method);
  useEffect(() => {
    dispatch(allSampleManagement());
    dispatch(AllTestMethod());
  }, [dispatch]);

  const all_chemist = useSelector((state) => state.common.all_chemist);

  useEffect(() => {
    dispatch(AllChemist());
  }, [dispatch]);
  return (
    <section className="Legal_Entity_Form">
      <div className="white_container customer_section">
        {/* ================= TOP ROW ================= */}
        <div className="row">
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Type Of Verification</Form.Label>
              <Controller
                name="type_of_verification_id"
                control={control}
                rules={{ required: "Type Of Verification is required" }}
                render={({ field }) => (
                  <Select
                    options={all_verification_type}
                    value={
                      all_verification_type?.find(
                        (o) => o.value === field.value,
                      ) || null
                    }
                    onChange={(e) => field.onChange(e?.value || null)}
                  />
                )}
              />
              {errors.type_of_verification_id && (
                <Form.Text className="text-danger">
                  {errors.type_of_verification_id.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>

          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Sample ID</Form.Label>
              <Controller
                name="sample_management_id"
                control={control}
                rules={{ required: "Sample is required" }}
                render={({ field }) => (
                  <Select
                    options={all_sample_management}
                    value={
                      all_sample_management?.find(
                        (o) => o.value === field.value,
                      ) || null
                    }
                    onChange={(e) => field.onChange(e?.value || null)}
                  />
                )}
              />
              {errors.sample_management_id && (
                <Form.Text className="text-danger">
                  {errors.sample_management_id.message}
                </Form.Text>
              )}{" "}
            </Form.Group>
          </div>

          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Test Method</Form.Label>
              <Controller
                name="test_method_id"
                control={control}
                rules={{ required: "Test Method is required" }}
                render={({ field }) => (
                  <Select
                    options={all_test_method}
                    value={
                      all_test_method?.find((o) => o.value === field.value) ||
                      null
                    }
                    onChange={(e) => field.onChange(e?.value || null)}
                  />
                )}
              />
              {errors.test_method_id && (
                <small className="text-danger">
                  {errors.test_method_id.message}
                </small>
              )}
            </Form.Group>
          </div>

          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Average</Form.Label>
              <Form.Control
                {...register("average", {
                  required: "Average is required",
                })}
              />
              {errors.average && (
                <small className="text-danger">{errors.average.message}</small>
              )}
            </Form.Group>
          </div>

          {/* <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Certified Value</Form.Label>
              <Form.Control
                {...register("certified_value", {
                  // required: "Certified Value is required",
                })}
              />
              {errors.certified_value && (
                <Form.Text className="text-danger">
                  {errors.certified_value.message}
                </Form.Text>
              )}
            </Form.Group>
          </div> */}
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Remark</Form.Label>
              <Form.Control
                placeholder="Enter Remark"
                {...register("remark", {
                  required: "Remark is required",
                })}
              />
              {errors.remark && (
                <Form.Text className="text-danger">
                  {errors.remark.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>
          <div className="col-md-4">
            <Form.Group className="form_group">
              <Form.Label>Checked By</Form.Label>
              <Controller
                name="chemist_assigned_id"
                control={control}
                rules={{ required: "Chemist is required" }}
                render={({ field }) => (
                  <Select
                    options={all_chemist}
                    value={
                      all_chemist?.find((o) => o.value === field.value) || null
                    }
                    onChange={(e) => field.onChange(e?.value || null)}
                  />
                )}
              />
              {errors.chemist_assigned_id && (
                <Form.Text className="text-danger">
                  {errors.chemist_assigned_id.message}
                </Form.Text>
              )}
            </Form.Group>
          </div>
        </div>

        <div className="inner_form_section_holder">
          <div className="row">
            <div className="col-md-12">
              <Form.Group className="form_group">
                <Form.Label>Certified Value Parameter</Form.Label>
                {errors.certified_param && (
                  <Form.Text className="text-danger">
                    {errors.certified_param.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {all_parameter?.map((item, index) => (
              <div
                className="col-xxl-1 col-xl-1 col-lg-2 col-md-3"
                key={item.value}
              >
                <div className="observation_box">
                  <div className="obs_label">{item.label}</div>
                  <div className="form_field_holder">
                    <Form.Control
                      placeholder={item.label}
                      {...register(`parameters.${index}.certified_value`, {
                        required: "Value is required",
                      })}
                    />
                    <input
                      type="hidden"
                      value={item.value}
                      {...register(`parameters.${index}.parameter_id`)}
                    />
                    {errors.parameters?.[index]?.certified_value && (
                      <small className="text-danger">
                        {errors.parameters[index].certified_value.message}
                      </small>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* ===== Result Value ===== */}
          <div className="row mt-3">
            <div className="col-md-12">
              <Form.Group className="form_group">
                <Form.Label>Result Value</Form.Label>
                {errors.result_param && (
                  <Form.Text className="text-danger">
                    {errors.result_param.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>

            {all_parameter?.map((item, index) => (
              <div
                className="col-xxl-1 col-xl-1 col-lg-2 col-md-3"
                key={`result-${item.value}`}
              >
                <div className="observation_box">
                  <div className="obs_label">{item.label}</div>
                  <div className="form_field_holder">
                    <Form.Control
                      placeholder={item.label}
                      {...register(`parameters.${index}.result_value`, {
                        required: "Result is required",
                      })}
                      // onKeyDown={(e) => {
                      //   const value = e.target.value;

                      //   // Allow control keys
                      //   if (
                      //     [
                      //       "Backspace",
                      //       "Delete",
                      //       "Tab",
                      //       "ArrowLeft",
                      //       "ArrowRight",
                      //     ].includes(e.key)
                      //   ) {
                      //     return;
                      //   }

                      //   // Allow numbers
                      //   if (/^[0-9]$/.test(e.key)) {
                      //     return;
                      //   }

                      //   // Allow ONE decimal point
                      //   if (e.key === "." && !value.includes(".")) {
                      //     return;
                      //   }

                      //   // Block everything else
                      //   e.preventDefault();
                      // }}
                    />

                    {errors.parameters?.[index]?.result_value && (
                      <small className="text-danger">
                        {errors.parameters[index].result_value.message}
                      </small>
                    )}
                  </div>
                </div>
              </div>
            ))}
          </div>

          {/* ===== Accuracy Acceptance ===== */}
          <div className="row mt-3">
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Date</Form.Label>
                <Form.Control
                  type="date"
                  placeholder="Enter Date"
                  {...register("date", {
                    required: "Date is required",
                  })}
                  onChange={(e) => {
                    let value = e.target.value;
                    const parts = value.split("-");

                    if (parts[0] && parts[0].length > 4) {
                      parts[0] = parts[0].slice(0, 4);
                      e.target.value = parts.join("-");
                    }
                  }}
                />
                {errors.date && (
                  <Form.Text className="text-danger">
                    {errors.date.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
            <div className="col-md-4">
              <Form.Group className="form_group">
                <Form.Label>Accuracy Acceptance</Form.Label>
                <Form.Check
                  type="checkbox"
                  label="Accepted"
                  {...register("accuracy_acceptance", {
                    required: "You must accept accuracy before submitting",
                  })}
                />
                {errors.accuracy_acceptance && (
                  <Form.Text className="text-danger">
                    {errors.accuracy_acceptance.message}
                  </Form.Text>
                )}
              </Form.Group>
            </div>
          </div>
        </div>

        {/* ================= FOOTER ================= */}
        <div className="permission_btn_holder">
          <Button className="permission_btn No_btn">Reset</Button>
          <Button
            type="button"
            className="permission_btn Yes_btn"
            onClick={handleSubmit(onSubmit)}
          >
            Save
          </Button>
        </div>
      </div>
    </section>
  );
}

export default Accuracy_Form;
